<template>
    <div class="w-full">
        <Back/>
        <div class="mx-auto">
            <div class="w-full">
                
                <div class="mt-5 md:w-1/2 mx-auto md:mt-0">
                    <form action="#" method="POST">
                        <div class="shadow sm:rounded-md sm:overflow-hidden">
                            <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
                                <div class="w-full">
                                        <div class="col-span-6 sm:col-span-3">
                                        <label for="first_name" class="block text-sm font-medium text-gray-700">Judul Video</label>
                                        <input  v-model="formSubject.title" type="text" name="first_name" id="first_name" autocomplete="given-name"
                                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                         </div>
                                     </div>

                                     <div class="w-full">
                                        <div class="col-span-6 sm:col-span-3">
                                        <label for="date" class="block text-sm font-medium text-gray-700">Ditayangkan Pada</label>
                                        <!-- <litepie-datepicker as-single v-model="formSubject.publishedAt" ></litepie-datepicker> -->
                                         <Calendar id="time24" class="w-full border-gray-500" v-model="formSubject.publishedAt" :showTime="true" :showSeconds="true" dateFormat="yy-mm-dd" />
                                         </div> 
                                     </div>

                                      <div class="w-full">
                                        <div class="col-span-6 sm:col-span-3">
                                        <label for="slug" class="block text-sm font-medium text-gray-700">Slug</label>
                                        <input v-model="formSubject.slug" type="text" name="slug" id="slug" autocomplete="given-name"
                                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                         </div>
                                     </div>

                                     <div v-if="formSubject.video" class="w-ful">
                                           <label class="block text-sm font-medium text-gray-700">File Video</label>
                                        
                                           <video class="w-full">
                                                <source :src="formSubject.video" type="video/mp4">
                                                Your browser does not support the video tag.
                                            </video>
                                                
                                      
                                     </div>

                                     <div class="w-full">
                                        <label for="country" class="block text-sm font-medium text-gray-700">Pilih Format Upload</label>
                                        <select id="format" name="format" autocomplete="format" v-model="format"
                                            class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                                            <option value="video">Video</option>
                                            <option value="link">Link</option>
                                        </select>
                                    </div>

                                    <div v-if="format === 'link'" class="w-full">
                                        
                                        <label for="link" class="block text-sm font-medium text-gray-700">
                                            Link
                                        </label>
                                        <div class="mt-1 flex rounded-md shadow-sm">
                                            <span
                                                class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                                                https://
                                            </span>
                                            <input type="text" name="link" id="link"
                                                v-model="formSubject.video"
                                                class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-r-md sm:text-sm border-gray-300"
                                                placeholder="www.example.com">
                                        </div>
                                    </div>

                                    <div v-else class="w-full">
                                        <label for="video" class="block text-sm font-medium text-gray-700">
                                            Video
                                        </label>
                                       
                                        <input @change="uploadVideo($event)" type='file' name="video" id="video" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                       
                                        
                                    </div>

                                     <div class="w-full">
                                        <label for="link" class="block text-sm font-medium text-gray-700">
                                            Thumbnail
                                        </label>
                                        <div v-if="formSubject.thumbnail">
                                            <img :src="formSubject.thumbnail" class="w-full" alt="">

                                        </div>
                                       <input @change="uploadThumbnail($event)" type='file' name="thumbnail" id="thumbnail" class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                                        
                                    </div>
                                

                                <div class="w-full">
                                    <label for="about" class="block text-sm font-medium text-gray-700">
                                        Deskripsi singkat
                                    </label>
                                    <div class="mt-1">
                                        <textarea v-model="formSubject.shortDescription" id="about" name="about" rows="3"
                                            class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                                            placeholder="you@example.com"></textarea>
                                    </div>
                                    <p class="mt-2 text-sm text-gray-500">
                                        Brief description for video.
                                    </p>
                                </div>

                                <div class="w-full">
                                    <label for="about" class="block text-sm font-medium text-gray-700">
                                        Deskripsi
                                    </label>
                                    <div class="mt-1">
                                        <textarea v-model="formSubject.description" id="about" name="about" rows="3"
                                            class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                                            placeholder="you@example.com"></textarea>
                                    </div>
                                    <p class="mt-2 text-sm text-gray-500">
                                        Description for video.
                                    </p>
                                </div>

                              <div class="w-full">
                                        <div class="col-span-6 sm:col-span-3">
                                        <label for="duration" class="block text-sm font-medium text-gray-700">Durasi</label>
                                        <input v-model="formSubject.duration" type="text" name="duration" id="duration" autocomplete="given-name"
                                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                         </div>
                                     </div>

                                <div class="w-full">
                                        <div class="col-span-6 sm:col-span-3">
                                        <label for="ordering" class="block text-sm font-medium text-gray-700">Ordering</label>
                                        <input v-model="formSubject.ordering" type="number" name="ordering" id="ordering" autocomplete="given-name"
                                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md">
                                         </div>
                                     </div>
                                      <div class="w-full">
                                    <div class="flex items-start">
                                        <div class="flex items-center h-5">
                                            <input id="isActive" name="isActive" type="checkbox" v-model="formSubject.isActive"
                                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                                        </div>
                                        <div class="ml-3 text-sm">
                                            <label for="isActive" class="font-medium text-gray-700">Aktif</label>
                                            <p class="text-gray-500">Centang untuk menandakan video ini aktif</p>
                                        </div>
                                    </div>
                                </div>

                                
                            </div>
                            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                <button @click.prevent="submit" type="submit"
                                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <Toast />
    </div>
</template>
<script>

import Back from '@/layout/Component/Back'
import moment from 'moment'
import {
    mapActions,
    mapGetters
} from 'vuex'

export default {

    components: {
        Back
    },

    data() {
        return {
            format: 'link',
            formSubject: {
                title: '',
                slug: '',
                classroomId: 0,
                classroomLevelId: 0,
                publishedAt: moment().format('YYYY-MM-DD HH:mm:00'),
                shortDescription: '',
                description: '',
                thumbnail: '',
                video: '',
                link: '',
                duration: '',
                isActive: false,
                status: 0,
                ordering: 0,
            },
            videoId: 0,

            classroomLevel: {},
        }
    },
    created() {
        this.classroomId = this.$route.params.classroomId
        this.videoId = this.$route.params.id
        if (this.classroomId && (this.classroom?.id != this.classroomId)) {
            this.getClassroomDetail()
        }
        if (this.videoId) {
            this.getSubject()
        }
    },
    computed: {
        ...mapGetters(["classroom", "video", "isLoadingVideo", "isSuccessVideo", "messageVideo"]),
    },

    methods: {
        ...mapActions(["fetchDetailClassroom", "fetchAllVideos", "fetchDetailVideo", "addVideo", "updateVideo"]),
        async getClassroomDetail() {
            await this.fetchDetailClassroom(this.classroomId)
            // console.log(this.classroom)
        },
        async getSubject() {
            await this.fetchDetailVideo(this.videoId)
            // console.log(this.video)
            if (this.video) {
                this.formSubject.title = this.video.title
                this.formSubject.slug = this.video.slug
                this.formSubject.shortDescription = this.video.short_description
                this.formSubject.description = this.video.description
                this.formSubject.video = this.video.video
                this.formSubject.link = this.video.video_link
                this.formSubject.duration = this.video.duration
                this.formSubject.ordering = this.video.ordering
                this.formSubject.thumbnail = this.video.thumbnail
                this.formSubject.publishedAt = moment(this.video.published_at).format(
                    'YYYY-MM-DD HH:mm:ss'
                )
                const active = this.video.status
                if (active == 1) {
                    this.formSubject.isActive = true
                } else {
                    this.formSubject.isActive = false
                }
                // cookies.set('publishedAt', this.formSubject.publishedAt)

            }


        },
        async submit() {
            this.convertStatus()
            this.formSubject.publishedAt = moment(this.formSubject.publishedAt).format(
                'YYYY-MM-DD HH:mm:00'
            )
            // console.log('test', this.classroom)
            this.formSubject.classroomLevelId = this.classroom.levels[0].id
            this.formSubject.classroomId = Number(this.classroomId)
            // console.log('form', this.formSubject)
            if (this.videoId) {
                if (
                    this.formSubject.title &&
                    this.formSubject.slug &&
                    this.formSubject.classroomId &&
                    this.formSubject.classroomLevelId &&
                    this.formSubject.shortDescription &&
                    this.formSubject.description 

                ) {

                    const video = {
                        id: this.videoId,
                        payload: this.formSubject
                    }

                    if (this.format === 'video') {
                        this.formSubject.link = ''
                        await this.updateVideo(video)

                        if (this.isSuccessVideo) {
                            this.fetchAllVideos(this.classroomId)
                            this.$toast.add({
                                severity: 'success',
                                summary: 'Success',
                                detail: this.messageVideo,
                                life: 1000
                            })
                            setTimeout(() => this.$router.go(-1), 1000)
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Failed',
                                detail: this.messageVideo
                            })
                        }
                    } else {
                        await this.updateVideo(video)

                        if (this.isSuccessVideo) {
                            this.fetchAllVideos(this.classroomId)
                            this.$toast.add({
                                severity: 'success',
                                summary: 'Success',
                                detail: this.messageVideo,
                                life: 1000
                            })
                            setTimeout(() => this.$router.go(-1), 1000)
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Failed',
                                detail: this.messageVideo
                            })
                        }
                    }



                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'semua form harus diisi',
                        life: 3000
                    })
                }

            } else {
                if (
                    this.formSubject.title &&
                    this.formSubject.slug &&
                    this.formSubject.classroomId &&
                    this.formSubject.classroomLevelId &&
                    this.formSubject.shortDescription &&
                    this.formSubject.description 

                ) {
                    if (this.format === 'video') {

                        this.formSubject.link = ''
                        await this.addVideo(this.formSubject)

                        if (this.isSuccessVideo) {
                            this.fetchAllVideos(this.classroomId)
                            this.$toast.add({
                                severity: 'success',
                                summary: 'Success',
                                detail: this.messageVideo,
                                life: 1000
                            })
                            setTimeout(() => this.$router.go(-1), 1000)
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Failed',
                                detail: this.messageVideo
                            })
                        }
                    } else {
                        await this.addVideo(this.formSubject)

                        if (this.isSuccessVideo) {
                            this.fetchAllVideos(this.classroomId)
                            this.$toast.add({
                                severity: 'success',
                                summary: 'Success',
                                detail: this.messageVideo,
                                life: 1000
                            })
                            setTimeout(() => this.$router.go(-1), 1000)
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Failed',
                                detail: this.messageVideo
                            })
                        }
                    }
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'semua form harus diisi',
                        life: 3000
                    })
                }



            }
        },

        convertStatus() {
            if (this.formSubject.isActive) {
                this.formSubject.status = 1
            } else {
                this.formSubject.status = 0
            }
        },
        uploadVideo(event) {
            this.formSubject.video = event.target.files[0]
        },
        uploadThumbnail(event) {
            this.formSubject.thumbnail = event.target.files[0]
        },
    }
}
</script>